import isPlainObject from 'lodash-es/isPlainObject.js';
// ------------------------------------------------------------
// APIS
// ------------------------------------------------------------
/**
 * Wrapper around global `cohesion` function.
 * @see https://redventures.atlassian.net/wiki/spaces/COHSN/pages/96711970265/Cohesion+Client+API
 */
export const cohesion = (eventName, ...args) => {
    if (typeof window !== 'undefined' && typeof window.cohesion === 'function') {
        return window.cohesion(eventName, ...args);
    }
    else {
        console.error('[cohesion-utils] window.cohesion is not defined');
    }
};
/**
 * Wrapper around global `tagular` function.
 * @see https://redventures.atlassian.net/wiki/spaces/COHSN/pages/99418865810/Client+API+-+Tagular
 */
export const tagular = (methodName, ...args) => {
    if (typeof window !== 'undefined' && typeof window.tagular === 'function') {
        return window.tagular(methodName, ...args);
    }
    else {
        console.error('[cohesion-utils] window.tagular is not defined');
    }
};
/**
 * Wrapper around global `preamp` function.
 * @see https://redventures.atlassian.net/wiki/spaces/COHSN/pages/19850036159/Client+API+-+Preamp
 */
export const preamp = (...args) => {
    if (typeof window !== 'undefined' && typeof window.preamp === 'function') {
        window.preamp(...args);
    }
    else {
        console.error('[cohesion-utils] window.preamp is not defined');
    }
};
/**
 * Wrapper around global `monarch` function.
 * @see https://redventures.atlassian.net/wiki/spaces/COHSN/pages/1427145833/Client+API+-+Monarch
 */
export const monarch = (...args) => {
    cohesion('monarch:ready', () => {
        if (typeof window !== 'undefined' && typeof window.monarch === 'function') {
            window.monarch(...args);
        }
        else {
            console.error('[cohesion-utils] window.monarch is not defined');
        }
    });
};
// ------------------------------------------------------------
// UTILITIES
// ------------------------------------------------------------
/**
 * Get valid JSON object from an unknown value, else return null.
 */
export function getJsonObject(value) {
    if (typeof value === 'string') {
        try {
            return JSON.parse(value);
        }
        catch {
            return null;
        }
    }
    else if (isPlainObject(value)) {
        return value;
    }
    else {
        // TODO: Add debug flag.
        // console.error('[getJsonObject] Could not get JSON object', value)
        return null;
    }
}
